export enum WatermarkType {
  /** 隐形水印 */
  hidden = 1,
  /** 显性水印 */
  visible = 2,
  /** 自定义不透明度 */
  custom = 3,
}
